import {Brick, registerBrick} from 'olympe';
import { createTheme, adaptV4Theme } from '@mui/material/styles';
import { orange, red } from '@mui/material/colors';

export default class SetTheme extends Brick {
    /**
   * Executed every time the brick receives a new trigger event.
   * Note that the method will be executed _even if_ an input () is undefined.
   *
   * @protected
   * @param {BrickContext} context
   * @param {!Array} inputs
   * @param {function()} forwardEvent
   */
    onUpdate(context, inputs, [forwardEvent]) {
        const theme = createTheme(adaptV4Theme({
            palette: {
                primary: {
                    main: '#F19100',
                },
                secondary: {
                    main: '#D00032',
                    contrastText: '#FFFFFF',
                },
                contrastThreshold: 3,
            },
        }));
        forwardEvent();
    }
}

registerBrick('017a39321563a2461074', SetTheme);
